
import { useQuery } from '@tanstack/react-query';
import { getSpecialties } from '@uplift/api';
import { BaseQueryOpts } from '../baseTypes';

export const useSpecialties = (opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'specialties' ],
    queryFn: getSpecialties,
    select: r => r.data,
    ...opts,
  });
};
